import React, { useEffect, useState } from 'react';
import PageTemplate from 'PageTemplates/PageTemplate';
import { StyledH1, StyledH3 } from 'components/header';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import FlexRow from 'PageTemplates/FlexRowTemplate';
import { Button } from 'react-bootstrap';
import { substractSimilarObjects } from 'services/utils/object';
import {
  calcNewOrderPrice,
  clearNewOrder,
} from 'services/store/actions/newOrder';
import { Redirect, useHistory, useLocation } from 'react-router';
import { setSpinner } from 'services/store/actions/view';
import { useAlert } from 'react-alert';
import { sendOrder } from 'services/apiRequests/orders/post';
import Legend from '../components/Order/Legend';
import SurfaceSummary from '../components/Order/SurfaceSummary';
import Summary from '../components/Order/Summary';
import ItemsList from '../components/Order/ItemsList';
import Data from '../components/Order/Data';
import CustomItemsList from '../components/Order/CustomItemsList';
import { useModal } from 'hooks/useModal';
import withContext from 'hoc/withContext';
import ConfirmNewPrice from '../components/modals/ConfirmNewPrice';
import ColorSamplesList from '../components/Order/ColorSamplesList';

const SubmitButton = styled(Button)`
  padding: 10px 30px;
  letter-spacing: 5px;
`;
const Wrapper = styled.div`
  width: 49%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const NewOrderSummary = ({ permissionContext }) => {
  const location = useLocation();
  const { pathname } = location;
  const history = useHistory();
  const dispatch = useDispatch();
  const alert = useAlert();
  const globalPrices = useSelector((state) => state.settings.prices);
  const order = useSelector((state) => state.newOrder);

  const [prices, setPrices] = useState(null);
  const [currentPrice] = useState(order.price);
  const { modal, showModal, closeModal } = useModal({
    confirmPrice: false,
  });

  useEffect(() => {
    if (order.userPrices && globalPrices) {
      const userPrices = substractSimilarObjects(
        globalPrices,
        order.userPrices,
      );
      setPrices(userPrices);
    }
  }, [order.userPrices, globalPrices]);

  useEffect(() => {
    if (prices) dispatch(calcNewOrderPrice(prices));
  }, [prices]);

  const handleSubmit = async () => {
    if (
      pathname.includes('edit') &&
      order.isPriceBlocked &&
      permissionContext === 'admin' &&
      currentPrice &&
      currentPrice !== order.price
    ) {
      return showModal('confirmPrice');
    } else {
      return postOrder(order);
    }
  };

  const postOrder = async (order) => {
    dispatch(setSpinner(true));
    await sendOrder(
      order,
      pathname.includes('neworder') ? 'new' : 'edit',
      (id) => {
        dispatch(setSpinner(false));
        alert.success('Zamówienie utworzone pomyślnie');
        dispatch(clearNewOrder());
        return history.push(`/order/${id}`);
      },
      (err) => {
        dispatch(setSpinner(false));
        console.error(err);
        if (err && err.toString().length > 25) alert.error('Błąd!');
        else alert.error(`${err}`);
        return history.push(`/order/${order._id}`);
      },
    );
  };

  console.log(order);
  if (
    !order.items.length &&
    !order.customItems.length &&
    !order.colorSamplesItems.length
  )
    return <Redirect to="/neworder" />;

  return (
    <PageTemplate>
      <StyledH1>
        {order.userName} -{' '}
        {typeof order.number === 'string'
          ? order.number.toUpperCase()
          : order.number}
      </StyledH1>
      <Data order={order} />
      <StyledH3>Elementy</StyledH3>
      <ItemsList order={order} />
      {order.customItems && order.customItems.length ? (
        <>
          <StyledH3>Elementy niestandardowe</StyledH3>
          <CustomItemsList order={order} />
        </>
      ) : null}
      {order.colorSamplesItems && order.colorSamplesItems.length ? (
        <>
          <StyledH3>Próbki kolorów</StyledH3>
          <ColorSamplesList order={order} />
        </>
      ) : null}
      <FlexRow justify="space-between" wrap>
        <Wrapper />
        <Wrapper>
          <Summary order={order} />
          <SurfaceSummary order={order} />
          <Legend />
        </Wrapper>
      </FlexRow>
      <SubmitButton disabled={!order.elements} onClick={handleSubmit}>
        Wyślij
      </SubmitButton>
      {/* MODALS */}
      {modal.confirmPrice && (
        <ConfirmNewPrice
          closeModal={closeModal}
          currentPrice={currentPrice}
          order={order}
          postOrder={postOrder}
        />
      )}
    </PageTemplate>
  );
};

export default withContext(NewOrderSummary);
